const ruleFactory = message => {
  return { required: true, message };
};

export default ruleFactory;
